import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CYRoutingModule } from './cy-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, CYRoutingModule],
})
export class CYModule {}
